import React from 'react';

import { useGetLibraryDictionary } from '../../hooks/use-get-library-dictionary';
import { ILibraryMeetingPlace } from '../../queries/fragments/libraryMeetingPlace';
import { OpeningHours } from '../opening-hours/opening-hours';

export interface HeaderOpeningHoursProps {
  meetingPlace: ILibraryMeetingPlace;
}

export const HeaderOpeningHours = ({
  meetingPlace,
}: HeaderOpeningHoursProps) => {
  const dictionary = useGetLibraryDictionary(meetingPlace?.node_locale);
  return (
    <div className="h-16 overflow-hidden hover:bg-background-secondary rounded-xl bg-background-primary-light p-4 text-bodys text-brand-grey-4">
      <div className="font-title text-headingxs">{meetingPlace?.name}</div>
      <OpeningHours
        openingHoursClosed={dictionary?.openingHoursClosed ?? ''}
        openingHoursClosedToday={dictionary?.openingHoursClosedToday ?? ''}
        openingHoursOpenToday={dictionary?.openingHoursOpenToday ?? ''}
        openingHours={meetingPlace?.openingHours}
        openingHoursExceptions={meetingPlace?.openingHoursExceptions}
        timezone={meetingPlace?.timezone}
        node_locale={meetingPlace?.node_locale}
        variant="today"
      />
    </div>
  );
};
